module.exports = __webpack_public_path__ + "static/media/empty-state-airports-visited.34001ebd.svg";